<template>
  <div class="pa-10">
    <div v-if="course.courses.length == 0">
      <no-data />
    </div>
    <div v-else>
      <h1>All Scenarios</h1>
      <CourseCard
        v-for="course in course.courses"
        :key="course.id"
        :course="course"
      />
      <div class="text-center">
        <v-pagination
          v-model="coursePage"
          :length="totalPages"
          @input="onPageChange"
          :total-visible="7"
        ></v-pagination>
      </div>
      <v-dialog v-model="loading" hide-overlay persistent width="300">
        <v-card color="primary" dark>
          <v-card-text>
            Please stand by
            <v-progress-linear
              indeterminate
              color="white"
              class="mb-0"
            ></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>

<script>
import CourseCard from '@/components/CourseCard.vue'
import NoData from '@/components/NoData.vue'
import { mapState } from 'vuex'
import store from '@/store/index'

function getPageCourses(routeTo, next) {
  const currentPage = parseInt(routeTo.query.page) || 0
  const sortQuery = routeTo.query.sort || 'publishDate,asc'
  store
    .dispatch('course/fetchCourses', {
      page: currentPage,
      sort: sortQuery
    })
    .then(() => {
      routeTo.params.page = currentPage
      routeTo.params.sort = sortQuery
      routeTo.params.loading = false
      next()
    })
}

export default {
  props: {
    page: {
      type: Number,
      required: false
    }
  },
  components: {
    CourseCard,
    NoData
  },
  data() {
    return {
      coursePage: this.page + 1 || 1,
      loading: false
    }
  },
  beforeRouteEnter(routeTo, routeFrom, next) {
    getPageCourses(routeTo, next)
  },
  beforeRouteUpdate(routeTo, routeFrom, next) {
    getPageCourses(routeTo, next)
  },
  computed: {
    hasNextPage() {
      return this.course.coursesTotal > this.page * this.course.perPage
    },
    totalPages() {
      return this.course.totalPages
    },
    currentPage() {
      return this.page + 1
    },
    ...mapState(['course'])
  },
  mounted() {
    if (this.$route.params.loading !== undefined) {
      this.loading = this.$route.params.loading
    }
  },
  methods: {
    onPageChange(page) {
      const sortQuery = this.$route.query.sort || 'publishDate,asc'
      const currentPage = page - 1
      this.loading = true
      this.$router.replace({
        name: 'course-list',
        query: { page: currentPage, sort: sortQuery }
      })
    }
  }
}
</script>

<style lang="scss" scoped></style>
